import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API}/contact`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone
      });

      if (response.data.status === 'success') {
        toast.success(response.data.message);
        setFormData({
          name: '',
          email: '',
          phone: ''
        });
      }
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Something went wrong. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl font-bold text-gold mb-6 tracking-wide">
            CONTACT US
          </h2>
          <p className="text-xl text-charcoal-400 leading-relaxed">
            Tell us a little about yourself to receive personalized details, brochures and exclusive offers for a seamless home-buying experience with us.
          </p>
        </div>

        {/* Contact Form */}
        <div className="max-w-3xl mx-auto">
          <form onSubmit={handleSubmit} className="space-y-8" data-testid="contact-form">
            {/* Full Name */}
            <div>
              <Label htmlFor="name" className="text-charcoal text-base mb-3 block font-light">
                Full Name *
              </Label>
              <Input
                id="name"
                name="name"
                type="text"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
                data-testid="contact-name-input"
                className="w-full bg-gray-50 border-2 border-gray-200 text-charcoal placeholder:text-gray-400 rounded-full px-6 py-6 text-base focus:bg-gray-100 focus:border-gold-300 transition-all"
              />
            </div>

            {/* Email and Phone Row */}
            <div className="grid md:grid-cols-2 gap-6">
              {/* Email */}
              <div>
                <Label htmlFor="email" className="text-charcoal text-base mb-3 block font-light">
                  Email Address *
                </Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  data-testid="contact-email-input"
                  className="w-full bg-gray-50 border-2 border-gray-200 text-charcoal placeholder:text-gray-400 rounded-full px-6 py-6 text-base focus:bg-gray-100 focus:border-gold-300 transition-all"
                />
              </div>

              {/* Phone */}
              <div>
                <Label htmlFor="phone" className="text-charcoal text-base mb-3 block font-light">
                  Phone *
                </Label>
                <div className="flex gap-2">
                  <div className="flex items-center bg-white border-2 border-gray-200 rounded-full px-4 py-3">
                    <span className="text-2xl mr-2">🇮🇳</span>
                    <span className="text-charcoal font-medium">+91</span>
                  </div>
                  <Input
                    id="phone"
                    name="phone"
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone number"
                    data-testid="contact-phone-input"
                    className="flex-1 bg-gray-50 border-2 border-gray-200 text-charcoal placeholder:text-gray-400 rounded-full px-6 py-6 text-base focus:bg-gray-100 focus:border-gold-300 transition-all"
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="text-center pt-6">
              <Button
                type="submit"
                disabled={isSubmitting}
                data-testid="contact-submit-button"
                className="bg-gold hover:bg-gold-600 text-navy px-16 py-7 text-lg font-semibold rounded-full transition-all hover:scale-105 shadow-lg"
              >
                {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
